import React from 'react';
import PropTypes from 'prop-types';
import classes from './styles.module.scss';
import { ReactComponent as ClearSvg } from '../../../../assets/icons/close.svg';
import { ReactComponent as SearchIcon } from '../../../../assets/icons/search.svg';

function InputField({
  value = '', onChange = () => {}, label = '', wrapperClassName = '', height = 50, labelDefaultPosition = 12,
  onPaste = () => {}, onKeyPress = () => {}, clearValue, clearBtnClassName = '', searchIconLeft, searchIconRight,
  type = 'text', placeholder = '', autoFocus, rest, pattern, textareaField, labelBG = '#FFFFFF', clearDefaultValue = '',
  disabled, error = '', errorClassName = '',
}) {
  const wrapperCls = [classes.text_field_wrapper, wrapperClassName];
  if (textareaField) wrapperCls.push(classes.textarea_field);

  if (error) wrapperCls.push(classes.error);

  const clearCls = [classes.clear_svg, clearBtnClassName];

  const inputCls = [];
  if (value?.toString() || placeholder) inputCls.push(classes.with_value);
  if (clearValue) inputCls.push(classes.with_clear_btn);
  if (searchIconLeft) inputCls.push(classes.with_search_icon_left);
  if (searchIconRight) inputCls.push(classes.with_search_icon_right);

  return (
    <div style={{ height }} className={wrapperCls.join(' ')}>
      {textareaField
        ? (
          <textarea
            className={inputCls.join(' ')}
            value={value}
            placeholder={placeholder}
            onChange={({ target }) => onChange(target.value, target)}
            disabled={disabled}
          />
        )

        : (
          <input
            className={inputCls.join(' ')}
            value={value}
            placeholder={placeholder}
            autoFocus={autoFocus}
            autoComplete={type === 'password' ? 'new-password' : 'off'}
            type={type}
            disabled={disabled}
            onChange={({ target }) => onChange(target.value, target)}
            onKeyPress={onKeyPress}
            onPaste={onPaste}
            {...rest}
          />
        )}

      {clearValue && value && (
        <ClearSvg
          className={clearCls.join(' ')}
          onClick={() => !disabled && onChange(clearDefaultValue)}
        />
      )}

      {(searchIconLeft || searchIconRight) && (
        <SearchIcon className={classes.search_svg} />
      )}

      {label
        && (
        <label
          style={{
            '--default-position': `${labelDefaultPosition}px`,
            '--label-bg': `${labelBG}`,
          }}
        >
          {label}
        </label>
        )}

      {!!error && typeof error === 'string' && <p className={`${classes.error_text} ${errorClassName}`}>{error}</p>}
    </div>
  );
}

InputField.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  wrapperClassName: PropTypes.string,
  clearBtnClassName: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  height: PropTypes.number,
  clearValue: PropTypes.bool,
  textareaField: PropTypes.bool,
  searchIconLeft: PropTypes.bool,
  searchIconRight: PropTypes.bool,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  labelDefaultPosition: PropTypes.number,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
  onPaste: PropTypes.func,
  type: PropTypes.string,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
  labelBG: PropTypes.string,
  clearDefaultValue: PropTypes.string,
  errorClassName: PropTypes.string,
};

export default InputField;
